<template>
    <div class="signLanguage">
        <div class="content">
            <img src="../assets/signLanguage/sign-language-reservation_2x.png">
            <div class="text">
                <span class="bigText" id="translate">手语翻译</span>
                <p class="smallText">为医院、银行、公检法、博物馆、电影院、图书馆等机构和个人提供线上或线下手语服务</p>
            </div>
        </div>
        <div class="content">
            <div class="text">
                <span class="bigText" id="signTrain">手语培训</span>
                <p class="smallText">为医院、银行、地铁、公检法、博物馆、电影院、图书馆等机构和个人提供手语培训服务</p>
            </div>
            <img src="../assets/signLanguage/sign-language-train_2x.png" style="border: 15px solid rgb(252, 197, 205)">
        </div>
        <div class="content">
            <img src="../assets/signLanguage/video-culture_2x.png">
            <div class="text">
                <span class="bigText" id="video">手语影视文化传播服务</span>
                <p class="smallText">为电视剧、电影、纪录片、图书等文化产品提供手语服务</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'signLanguageService'
}
</script>

<style scoped>
.content{
    width:75vw;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    padding: 12% 0px;
}
.content img{
    max-width:55%;
}
.bigText{
    font-size:3em;
    font-weight: 450;
}
.smallText{
    font-size:2em;
    font-weight: 300;
    letter-spacing: 1px;
}
.text{
    width:30%;
    text-align: left;
}
@media screen and (max-width: 1200px){
    .bigText{
        font-size: 2.5em;
    }
    .smallText{
        font-size: 1.5em;
    }
}
@media screen and (max-width: 950px){
    .bigText{
        font-size: 2.1em;
    }
    .smallText{
        font-size: 1.2em;
    }
}
@media screen and (max-width: 750px){
    .bigText{
        font-size: 1.8em;
    }
    .smallText{
        font-size: 1em;
    }
    p.smallText{
        line-height: 1.2;
    }
}
@media screen and (max-width: 600px){
    .bigText{
        font-size: 1.5em;
    }
    .smallText{
        font-size: 0.8em;
    }
}
@media screen and (max-width: 450px){
    .text{
        width:35%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/signLanguageService.vue